import { render, staticRenderFns } from "./Renewal.vue?vue&type=template&id=8353c634"
import script from "./Renewal.vue?vue&type=script&lang=js"
export * from "./Renewal.vue?vue&type=script&lang=js"
import style0 from "./Renewal.vue?vue&type=style&index=0&id=8353c634&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports